<template>
  <div class="in_out" :class="inOutHistory ? 'more_in' : ''">
    <div v-if="!inOutHistory" class="data-list">
      <ul v-if="personnelInOut.length > 0">
        <li v-for="(item, index) in personnelInOut" :key="index">
          <span class="li_icon"></span>
          <el-tooltip effect="dark" :content="item.userName+' '+item.event+item.electronicFenceName+' '+item.logTimestamp"
           placement="top" :disabled="inOutDisabled">
            <span class="inOutDisplay" @mouseenter="inOutWhenMouseEnter(index)">{{ item.userName }}
              <span class="inside_out">{{ item.event }}{{ item.electronicFenceName }}</span>
              <span>{{ item.logTimestamp }}</span>
            </span>
          </el-tooltip>
        </li>
      </ul>
      <ul v-if="inOutTwo.length > 0">
        <li v-for="(item, index) in inOutTwo" :key="index">
          <span class="li_icon"></span>
          <el-tooltip effect="dark" :content="item.userName+' '+item.event+item.electronicFenceName+' '+item.logTimestamp"
           placement="top" :disabled="inOutTwoDisabled">
            <span class="inOutTwoDisplay" @mouseenter="inOutTwoWhenMouseEnter(index)">{{ item.userName }}
              <span class="inside_out">{{ item.event }}{{ item.electronicFenceName }}</span>
              <span>{{ item.logTimestamp }}</span>
            </span>
          </el-tooltip>
        </li>
      </ul>
    </div>
    <div v-if="inOutHistory" class="more_table common-blue-contain">
      <div class="time"><SearchDate @handleSearch="handleSearch" :searchDate="currenNode"></SearchDate></div>
      <el-table :data="personnelInOut" style="width: 100%">
        <el-table-column type="index" :label="$t('SerialNo')" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ (accessParam.currentPage - 1) * accessParam.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" :label="$t('userNameH')"> </el-table-column>
        <el-table-column prop="helmetId" :label="$t('serialNumberP')"> </el-table-column>
        <el-table-column prop="event" :label="$t('eventH')"> </el-table-column>
        <el-table-column prop="electronicFenceName" :label="$t('Electronicfence')"> </el-table-column>
        <el-table-column prop="logTimestamp" :label="$t('time')"> </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="accessParam.currentPage"
        :page-size="accessParam.pageSize"
        layout="total, prev, pager, next"
        :total="accessParam.allPage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getGeoFences } from '@/api/log'
import { formatDate } from '@/util/date'
import SearchDate from '@/views/new-home/SearchDate.vue'
export default {
  props: {
    inOutHistory: {
      type: Boolean,
    },
    currenNode: {
      type: [Array, Object],
    },
  },
  components: {
    SearchDate,
  },
  data() {
    return {
      // 请求人员进出数据
      personnelInOut: [],
      // 请求人员进出参数（电子围栏log）
      accessParam: { currentPage: 1, pageSize: 20, allPage: 0, startTime: '', endTime: '' },
      // 如果数据多 分两列的 第二列
      inOutTwo: [],
      // 控制人员进出第一列悬浮显示
      inOutDisabled: true,
      // 控制人员进出第二列悬浮显示
      inOutTwoDisabled: true,
    }
  },
  methods: {
    // 控制人员进出第一列悬浮显示
    inOutWhenMouseEnter(index) {
      const cellChild = document.querySelectorAll('.inOutDisplay')[index]
      if (cellChild.scrollWidth > cellChild.offsetWidth) {
        this.inOutDisabled = false
      } else {
        this.inOutDisabled = true
      }
    },
    // 控制人员进出第二列悬浮显示
    inOutTwoWhenMouseEnter(index) {
      const cellChild = document.querySelectorAll('.inOutTwoDisplay')[index]
      if (cellChild.scrollWidth > cellChild.offsetWidth) {
        this.inOutTwoDisabled = false
      } else {
        this.inOutTwoDisabled = true
      }
    },
    // 日期子组件触发 处理事件
    handleSearch(val) {
      this.currenNode.startTime = val.logTimestampBegin
      this.currenNode.endTime = val.logTimestampEnd
      this.accessParam.currentPage = 1
      this.getAccess()
    },
    handleSizeChange(val) {
      this.accessParam.pageSize = val
      this.getAccess()
    },
    handleCurrentChange(val) {
      this.accessParam.currentPage = val
      this.getAccess()
    },
    // 人员进出
    getAccess() {// NOSONAR
      if (this.inOutHistory) {
        this.accessParam.pageSize = 12
      } else {
        this.accessParam.pageSize = 20
      }
      let param = {
        pageNum: this.accessParam.currentPage,
        pageSize: this.accessParam.pageSize,
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: formatDate(this.currenNode.endTime),
      }
      // 获取电子围栏table数据
      getGeoFences(param).then(res => {
        if (res.state === 0) {
          // 遍历循环 判断event的type传输代表的文字
          res.value.content.forEach(item => {
            switch (item.event) {
              case 0:
                item.event = this.$t('Stayinfence')
                break
              case 1:
                item.event = this.$t('Stayoutsidefence')
                break
              case 2:
                item.event = this.$t('getinto')
                break
              case 3:
                item.event = this.$t('leaveP')
                break
              default:
                item.event = this.$t('unknownP')
                break
            }
          })
          this.accessParam.allPage = res.value.totalElements
          this.personnelInOut = res.value.content
          if (!this.inOutHistory) {
            if (this.personnelInOut.length > 9) {
              this.personnelInOut = this.personnelInOut.slice(0, 9)
            }
            if (res.value.content.length > 9) {
              this.inOutTwo = res.value.content.slice(10, 19)
            }
          }
        }
      })
    },
  },
  created() {
    // this.getAccess()
  },
  watch: {
    currenNode: {
      handler() {
        this.getAccess()
      },
      deep: true,
    },
    inOutHistory: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAccess()
        }
      },
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.in_out
  width: 100%
  height: 100%
  margin: 0 auto
  .data-list
    height: 100%
  ul
    height: 99%
    width: 50%
    overflow: auto
    margin-top 10px
    float left
    li
      width: 100%
      display: flex
      align-items: center
      line-height: 36px
      overflow:hidden
      span
        overflow:hidden
        white-space:nowrap
        text-overflow:ellipsis
      .li_icon
        width: 8px
        height: 8px
        background: #FF3F63
        margin-right: 10px
      .inside_out
        margin: 0 10px
  .empty
    font-size: 16px
    color: #0E8BFF
    text-align: center
    margin-top 20px
.more_in
  width: 100%
  height 100%
  display: flex
  flex-direction: column
  align-items: center
  .select_date
    background: none
    box-shadow none
    height: 40px
    margin-bottom: 20px
  .more_table
    width 96%
    height 98%
  ul
    margin-left 80px
    margin-bottom: 20px
  .pagination
    margin-top 10px
>>> .el-table
  height 85% !important
  min-height: 60% !important
  overflow: auto
</style>
